// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"CopyTradingFeesSignUpSection_sectionWrapper__BDpnJ","image":"CopyTradingFeesSignUpSection_image__ayCaR","content":"CopyTradingFeesSignUpSection_content__nwJhr"};